module.exports = __webpack_public_path__ + "media/loop_fade.2cc6d224.mp3";